module.exports = __webpack_public_path__ + "img/c5201809-1.51900e4b.jpg";